// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"434e7849","453":"0ff96a23"}[chunkId] + ".chunk.js";
};